import dynamic from 'next/dynamic'

import wrapper from 'redux/store'
import { redis } from 'utils/redis'
import { withRedis } from 'api/callConstructor'
import { getCollectionsCall } from 'api/calls'

const CollectionsPage = dynamic(() => import('modules/collections/CollectionsPage/CollectionsPage'))
const HeadTags = dynamic(() => import('components/app/HeadTags/HeadTags'))

const CollectionsContainer = props => (
  <>
    <HeadTags
      title="Collections"
      description="Invest in your interests on MoneyMade. Explore investments in crypto, real estate, stocks and more."
    />
    <CollectionsPage {...props} />
  </>
)

export const getStaticProps = wrapper.getStaticProps(async () => {
  const collections = await withRedis(redis, getCollectionsCall(), '/collections')
  // if (!collections.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/collections?_sort=created_at:DESC&publishedStatus=published. ${collections.status} ${collections.message}`
  //   )

  return {
    props: {
      collections: collections.result
    },
    revalidate: 600 // 10 min
  }
})

export default CollectionsContainer
